import MaterialService from "../services/MaterialService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillMaterialTable = () => {
    return db.materials.count(async function (count: number){
        if(count > 0){
            //ArticlesSpec already populated
        } else {
            //ArticlesSpec Database is empty. Populating from ajax call...
            store.dispatch(setDBLoadingState(true));
            await MaterialService.getMaterials()
                .then((data) => {
                    //console.log(data)
                    //Got ajax response. We'll now add the objects.
                    //Calling bulkAdd() to insert objects...
                    if (data) {
                        return db.materials.bulkAdd(data);
                    }
                })
                .then(() => {
                    //Done populating.
                    return db.timestamps.add({ name: "materials", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteMaterialsTable = async () => {
    return db.materials.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateMaterialsTable = async () => {
    await MaterialService.getMaterials()
        .then(async (data) => {
            await deleteMaterialsTable().then(() => {
                //@ts-ignore
                return db.materials.bulkPut(data);
            })
        })
        .catch(err => console.log(err));
}